const $inject = ['$rootScope', '$q', '$http', 'moment', 'cartService', 'apiService', 'itinerariesService'];

const unusedTicketsService = ($rootScope, $q, $http, moment, cartService, apiService, itinerariesService) => {
  const service = {
    isActive: false,
    isEnabled: false,
    tickets: [],
    getTickets: getTickets,
    toggle: toggle,
    clear: clear,
    autoAllocate: true
  };

  $rootScope.$watchCollection(() => cartService.items, validate);

  $rootScope.$watchCollection(() => cartService.tickets, validate);

  return service;

  function getTickets() {
    const deferred = $q.defer();

    const apiConfig = window.svelteStore.apiConfig('ticketsOnHold', itinerariesService.itinerary.Identifier);

    $http.get(apiConfig.url, { apiVersion: apiConfig.version })
      .then(res => {
        let data = res.data;
        service.tickets = data;
        validate();
        deferred.resolve(service.tickets);
      })

      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function validate() {
    const orderedTickets = _.orderBy(service.tickets, 'Amount');

    orderedTickets.forEach((ticket) => {
      const matchingTicket = cartService.getMatchingTicket(ticket);
      const matchingCartItemTotal = cartService.getMatchingItemTotal(ticket);

      ticket.isDisabled = !matchingCartItemTotal || !!matchingTicket;

      if (matchingCartItemTotal < ticket.Value) {
        cartService.removeTicket(ticket);
        ticket.isDisabled = true;
      }
    });

    const activeTickets = orderedTickets.filter(ticket => !ticket.isDisabled);
    if (activeTickets.length > 0 && service.autoAllocate) {
      autoAllocate(activeTickets);
    } else {
      service.autoAllocate = true;
    }
  }

  function autoAllocate(tickets) {
    if (tickets.length === 1) {
      return cartService.addTicket(tickets[0]);
    }

    const expiries = tickets.sort((left, right) => {
      return moment.utc(left.ExpiryDate).diff(moment.utc(right.ExpiryDate))
    }).reverse();

    if (expiries[0].ExpiryDate === expiries[1].ExpiryDate) {
      const earliestDate = expiries.filter(ticket => ticket.ExpiryDate === expiries[0].ExpiryDate);
      const highestValue = earliestDate.sort((left, right) => left.Value - right.Value).pop();
      return cartService.addTicket(highestValue);
    } else {
      return cartService.addTicket(expiries[0]);
    }
  }

  function toggle() {
    service.isActive = !service.isActive;
  }

  function clear() {
    service.isActive = false;
    service.isEnabled = false;
    service.tickets = [];
  }
};

unusedTicketsService.$inject = $inject;

export default unusedTicketsService;



// WEBPACK FOOTER //
// ./src/services/unusedTicketsService.js